import ImportFIle from "../Components/ImportFIle";

const ImportDataPage = () => {
  return (
      <ImportFIle/>
  );
};

export default ImportDataPage;
